module.exports = __webpack_public_path__ + "img/8000e.dca0acb9.png";